import React from 'react'
import './winner-list.scss'
import List from '../../atoms/list/lis';

const WinnerList = props => {

    return (
        <>
            <div className="f-winner-list">
                {props.winners ? props.winners.map((price, index) => {
                    var winnerFilter = price.winners;
                    
                    if (props.letterSearch !== ""){
                        winnerFilter = price.winners.filter((info) =>
                            info.name.charAt(0).toLowerCase().indexOf(props.letterSearch.toLowerCase()) > -1
                        )
                    }else{
                        winnerFilter = price.winners.filter((info) =>
                            info.name.toLowerCase().indexOf(props.searchInput.toLowerCase()) > -1
                        )
                    }
                    return (<List key={index} price={price} index={index} winners={winnerFilter} />)
                }
                )
                :"Cargando Ganadoras..."}
                {/* {!(props.winners.lenght > 0) && "No se encontraron ganadoras"} */}
            </div>
        </>
    )
}

export default WinnerList
